import { Button, Modal } from 'antd';
import { useInitializeMeUserMutation } from 'api/UsersApi';
import LogoComponent from 'components/Common/LogoComponent/LogoComponent';
import { useCompanyContext } from 'contexts/CompanyContext';
import { useSelector } from 'react-redux';
import { closeModal, selectModalName } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import { logging } from 'utils/utils';
import './WelcomeModalComponent.css';

export const WELCOME_MODAL_NAME = 'WELCOME_MODAL_NAME';

function WelcomeModalComponent() {
  const { companyConfig } = useCompanyContext();

  const dispatch = useAppDispatch();

  const [initializeMeUser] = useInitializeMeUserMutation();

  const handleOk = async () => {
    try {
      await initializeMeUser().unwrap();
    } catch (e) {
      logging(e);
    } finally {
      dispatch(closeModal());
    }
  };

  return (
    <Modal open={true} footer={null} onCancel={() => handleOk()} className="size-sm">
      <div className="welcome-modal-component">
        {companyConfig.isEnterprise && <LogoComponent maxWidth={300} maxHeight={100} />}

        <h2>Welcome!</h2>

        {companyConfig.isEnterprise ? (
          <p className="main-text">
            <span style={{ color: `${companyConfig.colorPrimary}` }}>{companyConfig.companyName}</span> welcomes you to
            the Legacy & Life Review Program. This experience is designed to help you reflect on your life, preserve
            meaningful memories, and create personal messages for the people who matter most.
          </p>
        ) : (
          <p className="main-text">We're thrilled to have you join our community.</p>
        )}

        <Button type="primary" size="large" onClick={() => handleOk()}>
          Get Started!
        </Button>
      </div>
    </Modal>
  );
}

function WelcomeModalComponentWrapper() {
  const modalName = useSelector(selectModalName);

  return modalName === WELCOME_MODAL_NAME ? <WelcomeModalComponent /> : null;
}

export default WelcomeModalComponentWrapper;
